export default "__VITE_ASSET__BDopETdf__"